import { render } from "./Details.vue?vue&type=template&id=11e429fc"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render

export default script